module.exports = __webpack_public_path__ + "img/leaf.565d01cf.svg";